import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TimelineDayDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "row",
        alignItems: "center",
        ...webStyle({
            position: "sticky",
            top: 0
        })
    },
    line: {
        flexShrink: 1,
        flexGrow: 1
    }
});

export const useStyles = ({
    controlHeights,
    shapeConfigs,
    isInCard,
    borders,
    colors,
    spaces
}: TimelineDayDynamicStyleType) => {
    const styles = {
        container: {
            backgroundColor: isInCard ? colors.content.container.raised : colors.content.container.default,
            marginBottom: spaces.spacingXs,
            height: controlHeights.small,
            gap: spaces.spacingSm,
            ...webStyle({
                zIndex: shapeConfigs.layers.raised + 1
            })
        } as Mutable<ViewStyle>,
        line: {
            backgroundColor: colors.content.border.subtle,
            height: borders.separator
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
